export const CREATOR_WARNING_MESSAGE =
  "We detected suspicious activity on your account. If this continues, your account may be suspended.";

export const CREATOR_WARNING_POLICY_URL =
  "https://help.artha.link/en/articles/16973894-suspicious-traffic-fraud-policy";

export const CREATOR_WARNING_DURATION_HOURS = 72;

export const CREATOR_WARNING_EMAIL_STATUSES = [
  "pending",
  "sent",
  "failed",
] as const;

export type CreatorWarningEmailStatus =
  (typeof CREATOR_WARNING_EMAIL_STATUSES)[number];

export interface CreatorWarningFinding {
  key: string;
  title: string;
  status: string;
  score: number;
  confidence?: string;
  reasons: string[];
  counterEvidence: string[];
  limitations: string[];
  evidenceEventIds: string[];
  detectorVersion?: string | null;
}

export interface CreatorWarningEvidenceSnapshot {
  runId?: string | null;
  analysisVersion?: string | null;
  windowType: string;
  windowStart?: string | null;
  windowEnd?: string | null;
  assessmentStatus: string;
  assessmentConfidence?: string | null;
  assessmentReasons: string[];
  limitations: string[];
  findings: CreatorWarningFinding[];
}

export interface CreatorWarning {
  message: string;
  issuedAt: Date;
  expiresAt: Date;
  issuedBy: string;
  evidenceSnapshot: CreatorWarningEvidenceSnapshot;
  emailStatus: CreatorWarningEmailStatus;
  emailAttemptedAt?: Date;
  emailDeliveryId?: string;
  emailError?: string;
}

export interface ActiveCreatorWarning {
  message: string;
  issuedAt: string;
  expiresAt: string;
}
